import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catMotivosLicencia } from "../../Categorias y Estados/catMotivosLicencia";
import { PuestosTrabajo } from "../../PuestosTrabajo/PuestosTrabajo";
import { Personal } from "../Personal";

const columns = () =>
(
    {
        vc_puestos: new EntityColumn<string[]>({ name: 'vc_puestos', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Puestos', isArray: true }),
        vc_licencias: new EntityColumn<string[]>({ name: 'vc_licencias', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Licencias', isArray: true }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        vc_supervision: new EntityColumn<string[]>({ name: 'vc_supervision', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Supervisor', isArray: true }),
        b_activo: new EntityColumn<boolean>({ name: 'b_activo', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo personal activo' }),
        b_baja: new EntityColumn<boolean>({ name: 'b_baja', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo personal de baja' }),
        ...DefaultColumns()
    }
)


const lookups = () =>
(
    {
        'Puestos': {
            name: 'Puestos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new PuestosTrabajo(client, parentKeys)
        },
        'Licencias': {
            name: 'Licencias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catMotivosLicencia(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        }
    }
)

export class PersonalFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('PersonalFilters');
    }
}